export default [
  {
    id: 1,
    company: "Accenture",
    position: "Software Engineer",
    date: "Septemeber 2020 - present",
    desc: [
      {
        id: 1,
        name: "worked on frontend development using react",
      },
      {
        id: 2,
        name: "AWS certified solutions architect assosciate",
      },
      {
        id: 3,
        name: "worked on cloud deployments and automation",
      },
    ],
  },
]
